import { render } from "./EndorsementsSimp.vue?vue&type=template&id=4ebfbb80"
import script from "./EndorsementsSimp.vue?vue&type=script&lang=js"
export * from "./EndorsementsSimp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__